<template>
<div>
    <head-nav></head-nav>
    <div class="form-lib">
        <h3 class="tit">CART</h3>
        <table class="table shop_table">
            <thead>
                <tr>
                    <th class="product-name">Item</th>
                    <th class="product-price">Price</th>
                    <th class="product-remove">&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in library" :key="index" style="font-family:berleno">
                    <td class="product-name">{{item.name}}</td>
                    <td class="product-price">$ {{item.price }}</td>
                    <td class="product-remove">
                        <b-button size="sm" @click.stop="remove(item)" class="mr-1 mini-but">
                            X
                        </b-button>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr class="subtotal">
                    <td class="product-name-foot">Total</td>
                    <td class="product-total-foot"><span class="amount">$ {{total}}</span></td>
                    <td class="product-total-foot"></td>
                </tr>

            </tfoot>
        </table>

        <button  class="btn btn-dark" style="color:#fff" @click="backToShop">
           Continue Shopping            
        </button>
        <button v-if="library.length > 0" class="btn btn-dark ml-2" @click="packageNumber" style="color:#fff">
            Checkout
        </button>

    </div>
    <info></info>
</div>
</template>

<script>
import {
    mapActions,
    mapState,
    mapMutations
} from "vuex";
import headNav from '../components/navBar'
import info from '../components/info'
//import datos from "../assets/issue-pack.json";
export default {
    components: {
        headNav,
        info
    },
    data() {
        return {
         
        }
    },
  
    methods: {
        remove(item) {
            this.removeLibrary(item)
        },
        packageNumber() {
          //  this.getPackageId(this.library)
            if (this.token && this.logged) {
                this.$router.push('/payment')
            } else {
                this.$router.push('/register')
            }
        },
        backToShop(){
            if (this.token && this.logged) {
                this.$router.push('/home')
            } else {
                this.$router.push('/the-magazine')
            }

        },

        ...mapMutations('cart', [
            'removeLibrary',
            'payTotal',
            'getPackageId'
        ]),
    },
    computed: {
        total() {
            let sum = 0
            this.library.forEach(lib => {
                sum += lib.price
            })
            this.payTotal(sum)
            return sum
        },
        ...mapState('cart', [
            'library',
            'totalPay',
            'packageId'
        ]),
        ...mapState('inPlayer', [
            'user',
        ]),
        token(){
            return localStorage.getItem('token') ? true : false

        },
        logged(){
            return localStorage.getItem('logged') ? true : false

        }
    },

}
</script>

<style>
.form-lib {
    position: relative;
    z-index: 1;
    background: #1c1c1c;
    max-width: 800px;
    margin: 20px auto 40px;
    padding: 45px;
    text-align: left;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}

.form-lib button {
    font-family: 'lemon_milkregular';
    text-transform: uppercase;
    outline: 0;
    width: 46%;
    border: 0;
    padding: 15px;
    color: #FFFFFF;
    font-size: 14px;
    -webkit-transition: all 0.3 ease;
    transition: all 0.3 ease;
    cursor: pointer;
}

.form-lib .mini-but {
    font-family: 'lemon_milkregular';
    text-transform: uppercase;
    outline: 0;
    width: 100%;
    padding: 5px;
    border: 0;
    color: #FFFFFF;
    font-size: 14px;
    -webkit-transition: all 0.3 ease;
    transition: all 0.3 ease;
    cursor: pointer;

}

.form-lib .message {
    margin: 15px 0 0;
    color: #212529;
    font-size: 15px;
    text-decoration: none;
}

.tit {
    color: #fff;
    font: normal 200 18px/1 'AGNext', 'Helvetica', 'Arial', sans-serif;
    letter-spacing: 1px;
    padding-bottom: 23px;
    border-bottom: 1px solid #969696;
    margin-bottom: 15px;
}



.cart {
    width: 900px;
    padding: 25px 18px;
    margin: 5% auto;
    clear: both;
    background-color: #1c1c1c;
}

.product-name {
    width: 333px;
    color: #fff;
}

.product-price {
    width: 90px;
    color: #fff;
}

.product-remove {
    width: 7px;
    text-align: right;
    padding-right: 10px;
}

.shop_table {
    width: 100%;
    border: 0;
    /* border-top: 1px solid #969696;
        border-collapse: collapse;*/
    border-bottom: 1px solid #555;
}

h3+.shop_table {
    border-top: none;
    margin-top: -15px;
}

.shop_table th .shop_table td {
    border: 0;
    font: normal 100 12px/1 'BentonSans', 'Helvetica', 'Arial', sans-serif;
    vertical-align: middle;
    color: #fff;
}

.shop_table thead th,
.shop_table thead td {
    border-bottom: 1px solid #dee2e6;
    /* border-bottom: 1px solid #4d4d4d;*/
    height: 37px;
    vertical-align: middle;
    color: #fff;
}

.table th,
.table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #4d4d4d;
}

.subtotal td {
    color: #fff;
    height: 50px;
    vertical-align: top;
    padding-top: 15px;
}
</style>
